module.exports = __webpack_public_path__ + "static/media/camera_black.97006086.svg";